module.exports = __webpack_public_path__ + "img/icon_map_2_on_110.1c74a483.png";